import React from 'react';

export interface ChartTableToggleProps { value: 'chart' | 'table'; onChange(value: 'chart' | 'table'): void; label: string }

const ChartTableToggle: React.FC<ChartTableToggleProps> = ({ value, onChange, label }) => <fieldset>
  <legend className="sr-only">{label}</legend>
  <div className="inline-flex rounded-md border border-gray-300 p-0.5 dark:border-gray-600">
    {(['chart', 'table'] as const).map(option => <button key={option} type="button" aria-pressed={value === option} onClick={() => onChange(option)} className={`min-h-11 rounded px-3 text-sm font-semibold capitalize focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 ${value === option ? 'bg-club-blue-700 text-white' : 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800'}`}>{option}</button>)}
  </div>
</fieldset>;

export default ChartTableToggle;
